module.exports = __webpack_public_path__ + "img/pic_location_TainanCity.fab12db5.png";